// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3WFxX","inputWrap":"styles_inputWrap__a2Rho","input":"styles_input__l4z63"};